export class MobileConfigurationModel {
    public companyName: string;
    public companyPhone: string;
    public location: number;
    public mobilehireAndroidApplicationUpdateURL: string;
    public mobilehireApplicationVersion: string;
    public mobilehireAssignedJobsOnly: number;
    public mobilehireDisableEngineerSelection: number;
    public mobilehireDontLiveSearchCustomers: number;
    public mobilehireEnableBcar: number;
    public mobilehireEnableLocationOnPhoto: number;
    public mobilehireIOSApplicationUpdateURL: string;
    public mobilehireNoBlankSignature: number;
    public mobilehireScaffoldingInUse: number;
    public mobilehireHealthCareInUse: number;
    public mobilehireScaffoldingPackages: any;
    public mobilehireSearchAllDetailItems: number;
    public mobilehireServiceJobTasks5Options: number;
    public mobilehireSimpleOffhire: number;
    public mobilehireSpecificJobStatus: number;
    public mobilehireStepByStep: number;
    public mobilehireShowQuestions: number;
    public numberOfStockCounts: number;
    public photoReport: any;
    public rascorAndroidApplicationUpdateURL: string;
    public rascorApplicationVersion: string;
    public rascorEnableLocationOnPhoto: number;
    public rascorIOSApplicationUpdateURL: string;
    public mobilehireUseDocumentBeanQueue: number;
    public mobilehireSimpleEquipOffhire: number;
    public mobilehirePictureRequiredForDelivery: number;
    public mobilehireUnfulfilledCollection: number;
    public mobilehirePictureRequiredForCollection: number;
    public mobilehirePromptIfCertificateBlankOnServiceJob: number;
    public mobilehireSelfAssignDocuments: number;
    public mobilehireHideServiceJobCommentsField: number;
    public mobilehireDoNotPromptToCompleteServiceJob: number;
    public mobilehireFilterByCollectedAndVerified: number;
    public mobilehireServiceJobDontCompleteIfTasksFail: number;
    public mobilehireServiceAllowEditJobTypeOnExistingJobs: number;
    public mobilehireUseEngineerSignatureStoring: number;
    public mobilehireLinkEngineerToOperator: number;
    public mobilehireAllowItemDeletionOnDelivery: number;
    public mobilehireHideConsumablesOnOffhireCollection: number;
    
    [x: string]: any;
}
